import api from '../api/client'

const promotoresService = {
  // CRUD Promotores
  async listar(organizadorId, { ativo } = {}) {
    const qs = new URLSearchParams()
    if (ativo !== undefined) qs.set('ativo', ativo)
    const res = await api.get(`/organizadores/${organizadorId}/promotores?${qs}`)
    return res.data
  },

  async criar(organizadorId, data) {
    const res = await api.post(`/organizadores/${organizadorId}/promotores`, data)
    return res.data
  },

  async atualizar(organizadorId, promotorId, data) {
    const res = await api.put(`/organizadores/${organizadorId}/promotores/${promotorId}`, data)
    return res.data
  },

  async toggle(organizadorId, promotorId) {
    const res = await api.patch(`/organizadores/${organizadorId}/promotores/${promotorId}/toggle`)
    return res.data
  },

  async excluir(organizadorId, promotorId) {
    await api.delete(`/organizadores/${organizadorId}/promotores/${promotorId}`)
  },

  // Vínculo Leilão
  async listarPorLeilao(organizadorId, leilaoId) {
    const res = await api.get(`/organizadores/${organizadorId}/promotores/leilao/${leilaoId}`)
    return res.data
  },

  async vincular(organizadorId, leilaoId, data) {
    const res = await api.post(`/organizadores/${organizadorId}/promotores/leilao/${leilaoId}`, data)
    return res.data
  },

  async atualizarVinculo(organizadorId, leilaoId, vinculoId, data) {
    const res = await api.put(`/organizadores/${organizadorId}/promotores/leilao/${leilaoId}/${vinculoId}`, data)
    return res.data
  },

  async desvincular(organizadorId, leilaoId, vinculoId) {
    await api.delete(`/organizadores/${organizadorId}/promotores/leilao/${leilaoId}/${vinculoId}`)
  },

  async getDistribuicaoComissao(organizadorId, leilaoId) {
    const res = await api.get(`/organizadores/${organizadorId}/promotores/leilao/${leilaoId}/distribuicao-comissao`)
    return res.data
  },

  async getDistribuicaoComissaoPdf(organizadorId, leilaoId) {
    const res = await api.get(
      `/organizadores/${organizadorId}/promotores/leilao/${leilaoId}/distribuicao-comissao-pdf`,
      { responseType: 'blob', timeout: 60000 }
    )
    return res.data
  },
}

export default promotoresService

